import Component from 'vue-class-component'
import IconButton from '@/components/buttons/richmenu/IconButton';

@Component({
  name: 'h3-button',
})
export default class H3Button extends IconButton {
}
